import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/ProgressBar/sgds-progress-bar";
import { register } from "../../utils/ce-registry";

register("sgds-progress-bar", Component);

export default createComponent({
  react: React,
  tagName: "sgds-progress-bar",
  elementClass: Component,
  events: {}
});
